import React, {useState, useEffect} from 'react';
import {
    TextField,
    Button,
    Grid,
    Paper,
    Typography,
    MenuItem,
    Select,
    InputLabel,
    FormControl,
    FormHelperText,
    TableContainer,
    Table,
    TableHead,
    TableRow,
    TableCell,
    TableBody,
    FormControlLabel,
    Checkbox,
    RadioGroup, Radio, Divider,
} from '@mui/material';
import axios from 'axios';
import * as yup from 'yup';
import CustomAlert from '../../../components/ConfirmationModal/CustomAlert';
import ConfirmationModal from "../../../components/ConfirmationModal/ConfirmationModal";
import "./AddEmployeeForm.css"
import UserFetcher from "./UserFetcher";
import RolesEnum from "../../../enums/RolesEnum";
import VacationPopup from "../../../components/CaseInsideTable/VacationPopup";
import {Info as InfoIcon} from "@mui/icons-material";
import UserDataPopup from "../../../components/CaseInsideTable/userDataPopup";
import WorkerVacationsDialog from "../../../components/CaseInsideTable/WorkerVacationsDialog";
import PasswordChanger from "./PasswordChanger";

const AdminRegistration = () => {
    const [formData, setFormData] = useState({
        password: '',
        repeatPassword: '',
        email: '',
        pNumber: '',
        firstName: '',
        lastName: '',
        phone: '',
        roleName: '',
        departmentId: null,
        isOrganisation: false,
        deputyDepartments: [],
        canEditObjectRegister: false, // include this in your initial state
    });
    const [dialogOpen, setDialogOpen] = useState(false);
    const [alert, setAlert] = useState({show: false, message: '', type: ''});
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [departments, setDepartments] = useState([]);
    const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
    const [selectedUserId, setSelectedUserId] = useState(null);
    const [showPassError, setShowPassError] = useState(null);
    const [roles, setRoles] = useState([]);
    const [activeTab, setActiveTab] = useState('fileType');
    const [searchTerm, setSearchTerm] = useState("");
    const [formDataErrors, setFormDataErrors] = useState({
        password: '',
        repeatPassword: '',
        email: '',
        pNumber: '',
        firstName: '',
        lastName: '',
        phone: '',
        roleName: '',
        deputyDepartments: [],
        departmentId: null,
    });
    const [users, setUsers] = useState([]);
    const [isEditing, setIsEditing] = useState(false);
    const [editableUser, setEditableUser] = useState({});
    const [selectedRoleId, setSelectedRoleId] = useState('');
    const [selectedDepartmentId, setSelectedDepartmentId] = useState(null);
    const [selectedUser, setSelectedUser] = useState(null);
    const [vacationUsers, setVacationUsers] = useState([]);
    const [userDialogOpen, setUserDialogOpen] = useState(false);
    const [userId, setUserId] = useState('');
    const [selectedUserToChangePassword, setSelectedUserToChangePassword] = useState(null);
    const [isPasswordChangeDialogOpen, setIsPasswordChangeDialogOpen] = useState(false);
    const [deputyDepartments, setDeputyDepartments] = useState([]);
    const [selectedRoleFilter, setSelectedRoleFilter] = useState('');
    const [showOnlyVacation, setShowOnlyVacation] = useState(false);

    const fetchUsers = async () => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/User/GetAllInternalUsers`);

            const sortedUsers = response.data.data.result.sort((a, b) => {
                return a.firstName.localeCompare(b.firstName);
            });

            setUsers(sortedUsers);
        } catch (error) {
        }
    };

    useEffect(() => {
        if (users.length > 0) {
            const allDepartments = users
                .map(u => u.deputyDepartments)
                .filter(Boolean)
                .flatMap(dep => dep.split(','))
                .filter((v, i, a) => a.indexOf(v) === i);
            setDeputyDepartments(allDepartments);
        }
    }, [users]);


    const handleOpenUserDialog = (userId) => {
        setUserDialogOpen(true);
        setUserId(userId)
    };
    const handlePasswordDialogOpen = (userId) => {
        setIsPasswordChangeDialogOpen(true);
        setSelectedUserToChangePassword(userId)
    };
    const handleCloseUserDialog = () => {
        setUserDialogOpen(false);
        setUserId('')
    };

    const findUserById = (userId) => {
        const user = users.find(user => user.id === userId)
        if (user) {
            return `მოვალეობის შემსრულებელი: ${user.firstName} ${user.lastName}`
        }
        return 'მომხამრებელი არ არის აქტიური!'
    }

    const fetchVacationUsers = async () => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/GetAllVacantion`);
            if (response.data.success) {
                setVacationUsers(response.data.data);
            }
        } catch (error) {
        }
    };

    useEffect(() => {
        void fetchVacationUsers();
    }, []);
    const refreshVacations = () => {
        void fetchUsers();
        void fetchVacationUsers();
    };

    const checkIfUserOnVacation = (userId) =>
        vacationUsers.some(user => user.onVacationUserId === userId && user.isActive);

    const findReplacer = (userId) => {
        const replacer = vacationUsers.find(user => user.onVacationUserId === userId && user.isActive)
        if (replacer) {
            return replacer.temporaryExecutorUserId
        }
    }

    const findVacationDates = (userId) => {
        const replacer = vacationUsers.find(user => user.onVacationUserId === userId && user.isActive);
        if (replacer && replacer.vacantionStartDate && replacer.vacantionEndDate) {
            const endYear = new Date(replacer.vacantionEndDate).getFullYear();
            if (endYear === 2100) {
                return " უვადო შვებულება";
            }
            const startDate = new Date(replacer.vacantionStartDate).toLocaleDateString('en-GB');
            const endDate = new Date(replacer.vacantionEndDate).toLocaleDateString('en-GB');
            return ` ${startDate}-${endDate}`;
        } else {
            return "";
        }
    };



    const deleteVacation = async (temporaryExecutorUserId) => {
        const onVacationUserId = vacationUsers.find(user => user.onVacationUserId === temporaryExecutorUserId && user.isActive);

        try {
            const payload = {
                temporaryExecutorUserId: onVacationUserId.temporaryExecutorUserId,
                onVacationUserId: temporaryExecutorUserId,

            };

            await axios.post(`${process.env.REACT_APP_API_BASE_URL}/UndoVacasntion`, payload);
            void refreshVacations();

        } catch (error) {
        }
    };
    const handleCloseDialog = () => {
        setDialogOpen(false);
    };
    const handleOpenDialog = (userId) => {
        setSelectedUser(userId);
        setDialogOpen(true);
    };

    useEffect(() => {
        void fetchUsers();
    }, []);

    const getFilteredUsers = () => {
        return users.filter(user => {
            const matchesSearch =
                user.email.toLowerCase().includes(searchTerm.toLowerCase()) ||
                user.firstName.toLowerCase().includes(searchTerm.toLowerCase()) ||
                user.lastName.toLowerCase().includes(searchTerm.toLowerCase()) ||
                user.pNumber.toLowerCase().includes(searchTerm.toLowerCase());
            const matchesDepartment = selectedDepartmentId
                ? user.departmentId === selectedDepartmentId
                : true;
            const matchesRole = selectedRoleFilter
                ? user.roleName.toLowerCase() === selectedRoleFilter.toLowerCase()
                : true;
            const matchesVacation = showOnlyVacation
                ? checkIfUserOnVacation(user.id)
                : true;
            return matchesSearch && matchesDepartment && matchesRole && matchesVacation;
        });
    };


    const handleChangeRole = (e) => {
        const {value} = e.target;
        setFormData({...formData, roleName: value});
        setSelectedRoleId(value);
    };



    const handleDeleteClick = (userId) => {
        setSelectedUserId(userId);
        setIsDeleteModalOpen(true);
    };

    const deleteUser = async () => {
        try {
            const response = await axios.delete(`${process.env.REACT_APP_API_BASE_URL}/User/DeleteUser`, {
                data: {userId: selectedUserId},
            });

            if (response.data.success) {
                void fetchUsers();
                setAlert({show: true, message: 'ოპერაცია წარმატებით დასრულდა', type: 'success'});
            } else {
                setAlert({show: true, message: response.data.errorMessage, type: 'error'});
            }
        } catch (error) {
            setAlert({show: true, message: 'დაფიქსრიდა შეცდომა, ცადეთ მოგვიანებით', type: 'error'});
        }
    };

    const handleConfirmation = () => {
        setIsModalOpen(false);
        void submitRegistration();
    };


    useEffect(() => {
        const fetchData = async () => {
            try {
                const [departmentResponse, roleResponse] = await Promise.all([
                    axios.get(`${process.env.REACT_APP_API_BASE_URL}/GetAllDepartament`),
                    axios.get(`${process.env.REACT_APP_API_BASE_URL}/Role/GetAllRoles`),
                ]);

                setDepartments(departmentResponse.data.data);
                setRoles(roleResponse.data.data);
            } catch (error) {
            }
        };

        void fetchData();
    }, []);


    const handleChange = (e) => {
        const {name, value} = e.target;
        if (name === 'roleName') {
            const selectedRoleNormalizedName = roles.find(role => role.id === value)?.normaliseName;
            setFormData({...formData, roleName: selectedRoleNormalizedName});
        } else {
            setFormData({...formData, [name]: value});
        }
        validateField(name, value);
    };


    const handleChangeDepartment = (e) => {
        const {name, value} = e.target;
        if (name === 'roleName') {
            const selectedRoleNormalizedName = roles.find(role => role.id === value)?.normaliseName;
            setFormData({...formData, roleName: selectedRoleNormalizedName});
        } else {
            setFormData({...formData, [name]: value});
        }

    };

    const validateField = (name, value) => {
        try {
            registrationValidationSchema.validateSyncAt(name, {[name]: value});
            setFormDataErrors({...formDataErrors, [name]: ''});
        } catch (error) {
            setFormDataErrors({...formDataErrors, [name]: error.message});
        }
    };

    const registrationValidationSchema = yup.object().shape({
        password: yup.string()
            .required('სავალდებულო ველი')
            .min(6, 'პაროლი უნდა შეიცავდეს მინიმუმ 6 სიმბოლოს')
            .matches(
                /^(?=.*\d)(?=.*[A-Z])(?=.*[a-z])/,
                'პაროლი უნდა შეიცავდეს ციფრს, დიდ ასოს და პატარა ასოს'
            ),
        repeatPassword: yup.string().required('გთხოვთ განმეორებით შეიყვანოთ პაროლი'),
        email: yup.string().email('არასწორი ფორმატი').required('სახალდებულო ველი'),
        pNumber: yup.string().matches(/^\d{11}$/, 'არასწორი ფორმატი').required('სახალდებულო ველი'),
        firstName: yup.string().required('სახალდებულო ველი'),
        lastName: yup.string().required('სახალდებულო ველი'),
        phone: yup.string().required('სახალდებულო ველი'),
        roleName: yup.string().required('სახალდებულო ველი'),
        isOorganisation: yup.boolean(),


    });


    const isFormValid = () => {


        return Object.values(formData).every((x) => x !== '') && formData.password === formData.repeatPassword;
    };
    const handleUpdateUser = async () => {
        if (!editableUser) return;

        try {
            const response = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/User/UpdateUser`, editableUser, {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem('jwtToken')}`,
                },
            });

            if (response.data.success) {
                void fetchUsers();
                setIsEditing(false);
                setEditableUser({});
            }
        } catch (error) {
        }
    };

    const roleOptions = Object.entries(RolesEnum).map(([key, value]) => ({
        id: key,
        name: value,
    }));

    const handleSubmit = () => {
        if (formData.password !== formData.repeatPassword) {
            setFormDataErrors(prev => ({
                ...prev,
                repeatPassword: 'პაროლები არ ემთხვევა',
            }));
            return;
        }

        if (isFormValid()) {
            let updated = { ...formData };
            if (formData.roleName === 'HEADOFAGENCY') {
                updated.departmentId = 10;
            } else if (formData.roleName === 'DEPUTYHEADOFAGENCY') {
                updated.departmentId = 11;
            }
            setFormData(updated);
            setFormDataErrors(prev => ({ ...prev, departmentId: '' }));
            setIsModalOpen(true);
        }
    };


    const handleEditClick = (user) => {
        setIsEditing(true);
        setEditableUser({...user});
    };

    const submitRegistration = async () => {
        try {
            await registrationValidationSchema.validate(formData, {abortEarly: false});
            const submissionData = {
                ...formData,
                username: formData.email,
                isOrganisation: formData.isOrganisation || false,
                departmentId: formData.departmentId || 11,
                deputyDepartments: formData.deputyDepartments ? formData.deputyDepartments.join(',') : ''
            };

            const response = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/User/RegistrationByAdmin`, submissionData);

            if (response.data.success) {
                resetForm();
                setAlert({show: true, message: 'ოპეარცია წარმატებით დასრულდა', type: 'success'});
                await fetchUsers();
            } else {
                setAlert({
                    show: true,
                    message: response.data.errorMessage ? "response.data.errorMessage" : 'დაფიქსირდა შეცდომა',
                    type: 'error'
                });
            }
        } catch (error) {
            setAlert({show: true, message: 'დაფიქსირდა შეცდომა', type: 'error'});
        }
    };


    const resetForm = () => {
        setFormData({
            password: '',
            repeatPassword: '',
            email: '',
            pNumber: '',
            firstName: '',
            lastName: '',
            phone: '',
            roleName: '',
            departmentId: null,
            isOorganisation: false,
        });
        setFormDataErrors({
            password: '',
            repeatPassword: '',
            email: '',
            pNumber: '',
            firstName: '',
            lastName: '',
            phone: '',
            roleName: '',
            departmentId: null,
        });
        setSelectedRoleId('');
    };

    return (
        <div className="add-city-type-form">
            {userId && (
                <WorkerVacationsDialog open={userDialogOpen} onClose={handleCloseUserDialog} userId={userId}/>
            )}
            {users.length !== 0 && (
                <VacationPopup open={dialogOpen} onClose={handleCloseDialog}
                               users={users} userId={selectedUser} vacationUsers={vacationUsers}
                               onNewVacation={refreshVacations}/>
            )}
            <div style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center', // Optional: Centers items vertically if needed
                margin: '0 auto',     // Centers the div itself if it has a set width
                marginBottom: '20px',
                width: '100%',
            }} className="tab-navigation">
                <button
                    className={activeTab === 'fileType' ? 'active-tab' : ''}
                    onClick={() => setActiveTab('fileType')}
                >
                    თანამშრომლები
                </button>
                <button
                    className={activeTab === 'documentType' ? 'active-tab' : ''}
                    onClick={() => setActiveTab('documentType')}
                >გარე მომხმარებლები
                </button>
            </div>

            <PasswordChanger
                isOpen={isPasswordChangeDialogOpen}
                onClose={() => setIsPasswordChangeDialogOpen(false)}
                userId={selectedUserToChangePassword}
            />
            {activeTab === 'documentType' && (
                <UserFetcher/>
            )}
            {activeTab === 'fileType' && (
                <div>
                    <div className={""}>
                        <Grid>
                            <Paper style={{padding: 20, paddingLeft: '20%', paddingRight: '20%'}}>
                                <Typography variant="h6">თანამშრომლის რეგისტრაცია</Typography>
                                <div  >
                                    <input
                                        type="text"
                                        name="fakeUsername"
                                        style={{display: 'none'}}
                                    />
                                    <input
                                        type="password"
                                        name="fakePassword"
                                        style={{display: 'none'}}
                                    />

                                    <TextField
                                        label="ელ-ფოსტა"
                                        name="email"
                                        type="email"
                                        value={formData.email}
                                        fullWidth
                                        margin="normal"
                                        onChange={handleChange}
                                        error={Boolean(formDataErrors.email)}
                                        autoComplete="off"
                                        inputProps={{autoComplete: 'off'}}
                                    />

                                    {formDataErrors.email && (
                                        <FormHelperText error>
                                            {formDataErrors.email}
                                        </FormHelperText>
                                    )}

                                    <TextField
                                        label="პაროლი"
                                        name="password"
                                        type="password"
                                        value={formData.password}
                                        fullWidth
                                        margin="normal"
                                        onChange={handleChange}
                                        error={Boolean(formDataErrors.password)}
                                        autoComplete="off"
                                        inputProps={{autoComplete: 'new-password'}}
                                    />

                                    {formDataErrors.password && (
                                        <FormHelperText error>
                                            {formDataErrors.password}
                                        </FormHelperText>
                                    )}

                                    <TextField
                                        label="გაიმეორეთ პაროლი"
                                        name="repeatPassword"
                                        type="password"
                                        value={formData.repeatPassword}
                                        fullWidth
                                        margin="normal"
                                        onChange={handleChange}
                                        error={Boolean(formDataErrors.repeatPassword)}
                                    />
                                    {
                                        showPassError && (
                                            <FormHelperText error>პაროლები უნდა ემთხვეოდეს</FormHelperText>
                                        )
                                    }


                                    <TextField
                                        label="პირადი ნომერი"
                                        name="pNumber"
                                        value={formData.pNumber}
                                        fullWidth
                                        margin="normal"
                                        onChange={handleChange}
                                        error={Boolean(formDataErrors.pNumber)}
                                    />
                                    {formDataErrors.pNumber && (
                                        <FormHelperText error>{formDataErrors.pNumber}</FormHelperText>
                                    )}

                                    <TextField
                                        label="სახელი"
                                        name="firstName"
                                        value={formData.firstName}
                                        fullWidth
                                        margin="normal"
                                        onChange={handleChange}
                                        error={Boolean(formDataErrors.firstName)}
                                    />
                                    {formDataErrors.firstName && (
                                        <FormHelperText error>{formDataErrors.firstName}</FormHelperText>
                                    )}

                                    <TextField
                                        label="გვარი"
                                        name="lastName"
                                        value={formData.lastName}
                                        fullWidth
                                        margin="normal"
                                        onChange={handleChange}
                                        error={Boolean(formDataErrors.lastName)}
                                    />
                                    {formDataErrors.lastName && (
                                        <FormHelperText error>{formDataErrors.lastName}</FormHelperText>
                                    )}

                                    <TextField
                                        label="ტელეფონი (სახლის/მობილური)"
                                        name="phone"
                                        value={formData.phone}
                                        fullWidth
                                        margin="normal"
                                        onChange={handleChange}
                                        error={Boolean(formDataErrors.phone)}
                                    />
                                    {formDataErrors.phone && (
                                        <FormHelperText error>{formDataErrors.phone}</FormHelperText>
                                    )}


                                    <FormControl fullWidth margin="normal">
                                        <InputLabel id="role-label">როლი</InputLabel>
                                        <Select
                                            labelId="role-label"
                                            name="roleName"
                                            value={selectedRoleId}
                                            label="როლი"
                                            onChange={handleChangeRole}
                                            error={Boolean(formDataErrors.roleName)}
                                        >
                                            {roleOptions.filter(role => role.id !== 'user').map((role) => (
                                                <MenuItem key={role.id} value={role.id}>
                                                    {role.name}
                                                </MenuItem>
                                            ))}
                                        </Select>
                                        {formDataErrors.roleName && (
                                            <FormHelperText error>{formDataErrors.roleName}</FormHelperText>
                                        )}
                                    </FormControl>

                                    {formData.roleName !== 'HeadOfAgency' && formData.roleName !== 'DeputyHeadOfAgency' && (
                                        <FormControl fullWidth margin="normal">
                                            <InputLabel id="department-label">დეპარტამენტი</InputLabel>
                                            <Select
                                                labelId="department-label"
                                                name="departmentId"
                                                value={formData.departmentId}
                                                label="დეპარტამენტი"
                                                onChange={handleChangeDepartment}
                                                error={Boolean(formDataErrors.departmentId)}
                                            >
                                                {departments.map((department) => (
                                                    <MenuItem key={department.id} value={department.id}>
                                                        {department.name}
                                                    </MenuItem>
                                                ))}
                                            </Select>
                                        </FormControl>
                                    )}
                                    {formData.roleName === 'DeputyHeadOfAgency' && (
                                        <FormControl fullWidth margin="normal">
                                            <InputLabel id="department-label">დეპარტამენტი</InputLabel>
                                            <Select
                                                labelId="department-label"
                                                multiple
                                                name="deputyDepartments"
                                                value={formData.deputyDepartments}
                                                label="დეპარტამენტი"
                                                onChange={handleChangeDepartment}
                                                renderValue={(selected) =>
                                                    departments
                                                        .filter((d) => selected.includes(d.id))
                                                        .map((d) => d.name)
                                                        .join(', ')
                                                }
                                            >
                                                {departments.map((department) => (
                                                    <MenuItem
                                                        key={department.id}
                                                        value={department.id}
                                                        disabled={deputyDepartments.includes(department.id.toString())}
                                                    >
                                                        {department.name}
                                                    </MenuItem>
                                                ))}

                                            </Select>
                                        </FormControl>
                                    )}

                                    {selectedRoleId === "Expert" && (
                                        <div>
                                            <FormControlLabel
                                                control={
                                                    <Checkbox
                                                        checked={formData.canEditObjectRegister}
                                                        onChange={(e) => setFormData({
                                                            ...formData,
                                                            canEditObjectRegister: e.target.checked
                                                        })}
                                                    />
                                                }
                                                label="შეუძლია უწყებრივ რეესტრში ობიექტების რეგისტრაცია"
                                            />


                                        </div>
                                    )}


                                    <Button
                                        type="submit"
                                        variant="contained"
                                        color="primary"
                                        style={{marginTop: 20}}
                                        disabled={!isFormValid()}
                                        onClick={handleSubmit}
                                    >
                                        რეგისტრაცია
                                    </Button>
                                </div>
                            </Paper>


                            {alert.show && (
                                <CustomAlert
                                    message={alert.message}
                                    type={alert.type}
                                    onClose={() => setAlert({...alert, show: false})}
                                />
                            )}
                            {isModalOpen && (
                                <ConfirmationModal
                                    isOpen={isModalOpen}
                                    onRequestClose={() => setIsModalOpen(false)}
                                    onConfirm={handleConfirmation}
                                />
                            )}
                        </Grid>
                    </div>
                    <div>
                        <FormControl fullWidth margin="normal">
                            <InputLabel id="department-select-label">დეპარტამენტი</InputLabel>
                            <Select
                                labelId="department-select-label"
                                id="department-select"
                                value={selectedDepartmentId}
                                label="დეპარტამენტი"
                                onChange={(e) => setSelectedDepartmentId(e.target.value)}
                            >
                                <MenuItem value="">ყველა</MenuItem>
                                {departments.map((department) => (
                                    <MenuItem key={department.id} value={department.id}>{department.name}</MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                        <FormControl fullWidth margin="normal">
                            <InputLabel id="role-filter-label">როლი</InputLabel>
                            <Select
                                labelId="role-filter-label"
                                value={selectedRoleFilter}
                                label="როლი"
                                onChange={e => setSelectedRoleFilter(e.target.value)}
                            >
                                <MenuItem value="">ყველა</MenuItem>
                                {Object.entries(RolesEnum)
                                    .filter(([key]) => key !== 'admin' && key !== 'user')
                                    .map(([key, label]) => (
                                        <MenuItem key={key} value={key}>
                                            {label}
                                        </MenuItem>
                                    ))
                                }
                            </Select>
                        </FormControl>

                        <FormControlLabel
                            control={
                                <Checkbox
                                    checked={showOnlyVacation}
                                    onChange={e => setShowOnlyVacation(e.target.checked)}
                                />
                            }
                            label="მაჩვენე მხოლოდ შვებულებაში მყოფი თანამშრომლები"
                        />

                        <div className="search-container">
                            <TextField
                                label="ძიება"
                                variant="outlined"
                                fullWidth
                                value={searchTerm}
                                onChange={(e) => setSearchTerm(e.target.value)}
                                placeholder="ძიება ელ-ფოსტით, პირადი ნომრით, სახელით, გვარით..."
                                margin="normal"
                            />
                        </div>


                        <TableContainer className="wideTableContainer" component={Paper}
                                        style={{maxHeight: 900, overflow: 'auto', maxWidth: 1300}}>
                            <Table>
                                <TableHead>
                                    <TableRow>
                                        <TableCell align={"center"}>სახელი</TableCell>
                                        <TableCell align={"center"}>გვარი</TableCell>
                                        <TableCell align={"center"}>ელ-ფოსტა</TableCell>
                                        <TableCell align={"center"}>პირადი ნომერი</TableCell>
                                        <TableCell align={"center"}>ტელეფონი</TableCell>
                                        <TableCell align={"center"}>დეპარტამენტი</TableCell>
                                        <TableCell align={"center"}>როლი</TableCell>
                                        <TableCell align={"center"}>შუეძლია უწყებრივი რეესტრში ობიექტების
                                            დამატება</TableCell>
                                        <TableCell align={"center"}>თანამშრომელი შვებულებაშია</TableCell>
                                        <TableCell align={"center"}>შვებულებების ისტორია</TableCell>
                                        <TableCell
                                            style={{position: 'sticky', right: 0, background: 'white', zIndex: 2}}
                                            align={"center"}>ქმედება</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {getFilteredUsers().map((user) => (
                                        <TableRow key={user.id}>

                                            <TableCell>
                                                {isEditing && editableUser.id === user.id ? (
                                                    <TextField
                                                        value={editableUser.firstName}
                                                        onChange={(e) => setEditableUser({
                                                            ...editableUser,
                                                            firstName: e.target.value
                                                        })}
                                                    />
                                                ) : (
                                                    user.firstName
                                                )}
                                            </TableCell>
                                            <TableCell align={"center"}>
                                                {isEditing && editableUser.id === user.id ? (
                                                    <TextField
                                                        value={editableUser.lastName}
                                                        onChange={(e) => setEditableUser({
                                                            ...editableUser,
                                                            lastName: e.target.value
                                                        })}
                                                    />
                                                ) : (
                                                    user.lastName
                                                )}
                                            </TableCell>
                                            <TableCell align={"center"}>
                                                {isEditing && editableUser.id === user.id ? (
                                                    <TextField
                                                        value={editableUser.email}
                                                        onChange={(e) => setEditableUser({
                                                            ...editableUser,
                                                            email: e.target.value
                                                        })}
                                                    />
                                                ) : (
                                                    user.email
                                                )}
                                            </TableCell>
                                            <TableCell align={"center"}>
                                                {isEditing && editableUser.id === user.id ? (
                                                    <TextField
                                                        value={editableUser.pNumber}
                                                        onChange={(e) => setEditableUser({
                                                            ...editableUser,
                                                            pNumber: e.target.value
                                                        })}
                                                    />
                                                ) : (
                                                    user.pNumber
                                                )}
                                            </TableCell>
                                            <TableCell align={"center"}>
                                                {isEditing && editableUser.id === user.id ? (
                                                    <TextField
                                                        value={editableUser.phone}
                                                        onChange={(e) => setEditableUser({
                                                            ...editableUser,
                                                            phone: e.target.value
                                                        })}
                                                    />
                                                ) : (
                                                    user.phone
                                                )}
                                            </TableCell>

                                            {user.roleName === 'DeputyHeadOfAgency' ? (
                                                <TableCell align="center">
                                                    {isEditing && editableUser.id === user.id ? (
                                                        <>
                                                            {(() => {
                                                                const usedByOtherUsers = users
                                                                    .filter(u => u.id !== editableUser.id && u.deputyDepartments)
                                                                    .flatMap(u => u.deputyDepartments.split(','))
                                                                    .filter(Boolean);

                                                                return (
                                                                    <Select
                                                                        style={{maxWidth: 250}}
                                                                        multiple
                                                                        value={editableUser.deputyDepartments ? editableUser.deputyDepartments.split(',').map(Number) : []}
                                                                        onChange={(e) => {
                                                                            const selectedValues = e.target.value;
                                                                            setEditableUser({
                                                                                ...editableUser,
                                                                                deputyDepartments: selectedValues.join(',')
                                                                            });
                                                                        }}
                                                                        renderValue={(selected) =>
                                                                            departments
                                                                                .filter((d) => selected.includes(d.id))
                                                                                .map((d) => d.name)
                                                                                .join(', ')
                                                                        }
                                                                    >
                                                                        {departments.map((department) => (
                                                                            <MenuItem
                                                                                key={department.id}
                                                                                value={department.id}
                                                                                disabled={usedByOtherUsers.includes(department.id.toString())}
                                                                            >
                                                                                {department.name}
                                                                            </MenuItem>
                                                                        ))}
                                                                    </Select>
                                                                );
                                                            })()}
                                                        </>
                                                    ) : (
                                                        <>
                                                            {user.deputyDepartments
                                                                ?.split(',')
                                                                .map((id) => departments.find((d) => d.id === Number(id))?.name)
                                                                .filter(Boolean)
                                                                .map((name, index, arr) => (
                                                                    <React.Fragment key={index}>
                                                                        <div>{name}</div>
                                                                        {index < arr.length - 1 && <Divider/>}
                                                                    </React.Fragment>
                                                                ))}
                                                        </>
                                                    )}
                                                </TableCell>

                                            ) : (
                                                <TableCell align={"center"}>
                                                    {isEditing && editableUser.id === user.id ? (
                                                        <Select
                                                            style={{maxWidth: 150}}
                                                            value={editableUser.departmentId}
                                                            onChange={(e) => setEditableUser({
                                                                ...editableUser,
                                                                departmentId: e.target.value,
                                                            })}
                                                        >
                                                            {departments.map((department) => (
                                                                <MenuItem key={department.id} value={department.id}>
                                                                    {department.name}
                                                                </MenuItem>
                                                            ))}
                                                        </Select>
                                                    ) : (
                                                        departments.find(dept => dept.id === user.departmentId)?.name || user.departmentId
                                                    )}
                                                </TableCell>
                                            )}

                                            <TableCell align={"center"}>
                                                {isEditing && editableUser.id === user.id ? (
                                                    <Select
                                                        value={editableUser.roleName}
                                                        onChange={(e) => setEditableUser({
                                                            ...editableUser,
                                                            roleName: e.target.value
                                                        })}
                                                        fullWidth
                                                    >
                                                        {Object.entries(RolesEnum).map(([roleKey, roleValue]) => (
                                                            <MenuItem key={roleKey} value={roleKey}>
                                                                {roleValue}
                                                            </MenuItem>
                                                        ))}
                                                    </Select>
                                                ) : (
                                                    RolesEnum[user.roleName] || user.roleName
                                                )}
                                            </TableCell>
                                            <TableCell align={"center"}>
                                                {(isEditing && editableUser.id === user.id && user.roleName === "Expert") ? (
                                                    <FormControl>
                                                        <RadioGroup
                                                            row
                                                            value={editableUser.canEditObjectRegister ? 'yes' : 'no'}
                                                            onChange={(e) => setEditableUser({
                                                                ...editableUser,
                                                                canEditObjectRegister: e.target.value === 'yes'
                                                            })}
                                                        >
                                                            <FormControlLabel value="yes" control={<Radio/>}
                                                                              label="კი"/>
                                                            <FormControlLabel value="no" control={<Radio/>}
                                                                              label="არა"/>
                                                        </RadioGroup>
                                                    </FormControl>
                                                ) : (
                                                    user.canEditObjectRegister || user.roleName !== "Expert" ? 'კი' : 'არა'
                                                )}
                                            </TableCell>
                                            <TableCell align={"center"} style={{minWidth: 300}}>

                                                {checkIfUserOnVacation(user.id) ? "კი " : "არა "}
                                                {checkIfUserOnVacation(user.id) ?  (
                                                    <div>
                                                        ({findUserById(findReplacer(user.id))})
                                                        {(findVacationDates(user.id))}
                                                    </div>
                                                ) : (
                                                    <div>
                                                        {user.vacantionStartDate && user.vacantionEndDate && (
                                                            <>
                                                                {"შემდეგი შვებულება: "}
                                                                {new Date(user.vacantionStartDate).toLocaleDateString("en-GB")}
                                                                -
                                                                {new Date(user.vacantionEndDate).toLocaleDateString("en-GB")}
                                                            </>
                                                        )}
                                                    </div>
                                                )}
                                            </TableCell>
                                            <TableCell align={"center"}> <InfoIcon
                                                className="user-info-icon"
                                                onClick={() => handleOpenUserDialog(user.id)}
                                            />
                                            </TableCell>


                                            <TableCell
                                                style={{
                                                    position: 'sticky',
                                                    right: 0,
                                                    background: 'white',
                                                    zIndex: 2,
                                                    boxShadow: '-5px 0 5px -3px rgba(0, 0, 0, 0.2), -8px 0 10px -5px rgba(0, 0, 0, 0.1)'
                                                }}
                                                align={"center"}>
                                                {isEditing && editableUser.id === user.id ? (
                                                    <>
                                                        <Button
                                                            variant="contained"
                                                            color="primary"
                                                            onClick={handleUpdateUser}
                                                            style={{width: 210}}
                                                        >
                                                            შენახვა
                                                        </Button>
                                                        <Button
                                                            variant="contained"
                                                            color="secondary"
                                                            onClick={() => {
                                                                setIsEditing(false);
                                                                setEditableUser({});
                                                            }}
                                                            style={{width: 210, marginTop: 5}}
                                                        >
                                                            გაუქმება
                                                        </Button>
                                                    </>
                                                ) : (
                                                    <>
                                                        <Button
                                                            variant="contained"
                                                            onClick={() => handleEditClick(user)}
                                                            style={{width: 210}}
                                                        >
                                                            რედაქტირება
                                                        </Button>
                                                        <Button
                                                            variant="contained"
                                                            color="error"
                                                            onClick={() => handleDeleteClick(user.id)}
                                                            style={{width: 210, marginTop: 5}}
                                                        >
                                                            წაშლა
                                                        </Button>
                                                        {!checkIfUserOnVacation(user.id) ? (
                                                            <Button
                                                                variant="contained"
                                                                color="secondary"
                                                                onClick={() => handleOpenDialog(user.id)}
                                                                style={{width: 210, marginTop: 5}}
                                                            >
                                                                შვებულება
                                                            </Button>
                                                        ) : (
                                                            <Button
                                                                variant="contained"
                                                                color="secondary"
                                                                onClick={() => deleteVacation(user.id)}
                                                                style={{width: 210, marginTop: 5}}
                                                            >
                                                                შვებულების დასრულება
                                                            </Button>
                                                        )}
                                                        <Button
                                                            variant="contained"
                                                            color="secondary"
                                                            onClick={() => handlePasswordDialogOpen(user.id)}
                                                            style={{width: 210, marginTop: 5}}
                                                        >
                                                            პაროლის შეცვლა
                                                        </Button>

                                                    </>
                                                )}
                                            </TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>


                            </Table>
                        </TableContainer>
                    </div>
                    {isDeleteModalOpen && (
                        <ConfirmationModal
                            isOpen={isDeleteModalOpen}
                            onRequestClose={() => setIsDeleteModalOpen(false)}
                            onConfirm={() => {
                                void deleteUser();
                                setIsDeleteModalOpen(false);
                            }}
                        />
                    )}
                </div>
            )}
        </div>
    );
};

export default AdminRegistration;
